<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">
        {{ $t("receipts") }} {{ $t("templates") }}
      </div>
      <!-- <router-link class="btn-blue" to="add-receipts-template">{{ $t('add') }}</router-link> -->
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div v-if="TemplateList.length > 0" class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'rtemp_name'"
                @click="onSortValue('rtemp_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('rtemp_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('rtemp_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("receipts") }} {{ $t("templates") }}
            </th>
            <th class="text-right">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(templatedata, templatedataIndex) in TemplateList"
            :key="templatedataIndex"
          >
            <td>{{ templatedata.rtemp_name }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <!-- <label class="ios-switch">
                  <input
                    :checked="templatedata.rtemp_is_active == 'Y'"
                    type="checkbox"
                    class="ios-checkbox"
                  />
                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    templatedata.rtemp_is_active == 'Y'
                      ? 'active'
                      : templatedata.rtemp_is_active == 'Y' && 'inactive'
                  "
                />
                <b-dropdown variant="edit" class="ml-4">
                  <!-- to="edit-ticket-templates -->
                  <!-- <b-dropdown-item v-on:click="onTicketTemp('Edit', templatedata.rtemp_id)">
                    <span class="edit-pen"></span>
                    {{ $t('edit') }}
                  </b-dropdown-item>-->
                  <!-- to="view-ticket-templates -->
                  <b-dropdown-item
                    v-on:click="onTicketTemp('View', templatedata.rtemp_id)"
                  >
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="TemplateList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      TemplateList: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  beforeMount() {
    this.getReceiptTemplateList();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getReceiptTemplateList();
      } else {
        this.currentPage = event;
        this.getReceiptTemplateList();
      }
    },
    onTicketTemp: function(type, id) {
      if (type == "Edit") {
        this.$router.push({
          path: "/master/edit-receipts-template",
          query: { rtemp_id: id }
        });
      } else {
        this.$router.push({
          path: "/master/view-receipts-template",
          query: { rtemp_id: id }
        });
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getReceiptTemplateList();
    },

    getReceiptTemplateList: function() {
      let body = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby
      };
      MasterService.GetReceiptTemplate(body).then(response => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ReceiptsTemplate/receiptsTemplate.vue